/* Vessel Builder (Slim and Insulated). Pre-order: products tagged 'preorder' switch the button label and add a 'Pre-order' line property. */
(function () {
  if (customElements.get('vessel-builder-insulated')) return;

  class VesselBuilderInsulated extends HTMLElement {
    constructor() {
      super();
      this._state = { cap: null, strap: null, sleeve: null, engraving: null };
      this._engravingVariant = null;
    }

    connectedCallback() {
      this._currency = this.dataset.currency || 'AUD';
      const defaultCap = this.querySelector('.vb-swatch[data-part="cap"].is-selected');
      if (defaultCap) this._state.cap = this._read(defaultCap);

      this.addEventListener('click', this._onClick.bind(this));
      const engravingInput = this.querySelector('[data-engraving-text]');
      if (engravingInput) engravingInput.addEventListener('input', this._onEngravingInput.bind(this));

      this._initCarousels();
      this._initStickyAtc();
      this._updatePreorder();
    }

    _initStickyAtc() {
      const inlineBtn = this.querySelector('.vessel-builder__footer [data-vessel-atc]');
      const stickyBar = this.querySelector('[data-vessel-sticky-atc]');
      if (!inlineBtn || !stickyBar || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
      }, { threshold: 0 });
      observer.observe(inlineBtn);
    }

    _initCarousels() {
      const update = (el) => {
        const hasOverflow = el.scrollWidth > el.clientWidth + 1;
        const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
        el.classList.toggle('has-more', hasOverflow && !atEnd);
      };
      this.querySelectorAll('.vessel-builder__swatches--carousel').forEach((el) => {
        update(el);
        el.addEventListener('scroll', () => update(el), { passive: true });
        window.addEventListener('resize', () => update(el));
      });
    }

    _onClick(e) {
      const engravingOption = e.target.closest('.vb-engraving-option:not(:disabled)');
      const previewLink = !engravingOption && e.target.closest('[data-engraving-preview-link]');
      const modalClose  = !engravingOption && !previewLink && e.target.closest('[data-engraving-modal-close]');
      const none   = !engravingOption && !previewLink && !modalClose && e.target.closest('.vb-none');
      const swatch = !engravingOption && !previewLink && !modalClose && !none && e.target.closest('.vb-swatch:not(:disabled)');
      const atc    = e.target.closest('[data-vessel-atc]');

      if (engravingOption) this._pickEngravingOption(engravingOption);
      else if (previewLink) this._openEngravingModal();
      else if (modalClose)  this._closeEngravingModal();
      else if (none)        this._pickNone(none.dataset.part);
      else if (swatch)      this._pick(swatch);
      else if (atc)         this._addToCart();
    }

    _read(btn) {
      return {
        variantId: Number(btn.dataset.variantId),
        price:     Number(btn.dataset.price),
        title:     btn.dataset.title,
        colorName: btn.dataset.color || btn.dataset.title,
        image:     btn.dataset.image,
        backImage: btn.dataset.backImage || '',
        overlay:   btn.dataset.overlay || '',
        preorder:  btn.dataset.preorder === 'true',
      };
    }

    _pick(btn) {
      const part = btn.dataset.part;
      this._deselect(part);
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      this._state[part] = this._read(btn);
      this._showPreview(part, this._state[part]);
      this._updateTotal();
      this._clearError();
    }

    _pickNone(part) {
      this._deselect(part);
      const pill = this.querySelector(`.vb-none[data-part="${part}"]`);
      if (pill) { pill.classList.add('is-selected'); pill.setAttribute('aria-pressed', 'true'); }
      this._state[part] = null;
      this._clearPreview(part);
      this._updateTotal();
      this._clearError();
    }

    _deselect(part) {
      this.querySelectorAll(`.vb-swatch[data-part="${part}"], .vb-none[data-part="${part}"]`).forEach(el => {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
    }

    _pickEngravingOption(btn) {
      const mode = btn.dataset.engravingOption;
      this.querySelectorAll('.vb-engraving-option').forEach(el => {
        el.classList.toggle('is-selected', el === btn);
        el.setAttribute('aria-pressed', el === btn ? 'true' : 'false');
      });
      const inputWrap = this.querySelector('[data-engraving-input]');
      const input     = this.querySelector('[data-engraving-text]');

      if (mode === 'text') {
        this._engravingVariant = { variantId: Number(btn.dataset.variantId), price: Number(btn.dataset.price) };
        if (inputWrap) inputWrap.classList.add('is-visible');
        if (input) input.focus();
        this._syncEngravingState();
      } else {
        this._engravingVariant = null;
        if (inputWrap) inputWrap.classList.remove('is-visible');
        if (input) input.value = '';
        this._updateEngravingCounter(0);
        this._updatePreviewLinkVisibility();
        this._closeEngravingModal();
        this._state.engraving = null;
        this._updateTotal();
      }
      this._clearError();
    }

    _onEngravingInput() {
      const input = this.querySelector('[data-engraving-text]');
      const text  = (input.value || '').slice(0, 3);
      this._updateEngravingCounter(text.length);
      this._updatePreviewLinkVisibility();
      this._updateModalText(text);
      this._syncEngravingState();
    }

    _syncEngravingState() {
      const input = this.querySelector('[data-engraving-text]');
      const text  = input ? input.value.trim().slice(0, 3) : '';
      this._state.engraving = (this._engravingVariant && text)
        ? { variantId: this._engravingVariant.variantId, price: this._engravingVariant.price, text }
        : null;
      this._updateTotal();
    }

    _updateEngravingCounter(len) {
      const el = this.querySelector('[data-engraving-counter]');
      if (el) el.textContent = `${len}/3`;
    }

    _updatePreviewLinkVisibility() {
      const link  = this.querySelector('[data-engraving-preview-link]');
      const input = this.querySelector('[data-engraving-text]');
      if (!link) return;
      link.classList.toggle('is-visible', !!(this._engravingVariant && input && input.value.trim().length > 0));
    }

    _updateModalText(text) {
      const span = this.querySelector('[data-engraving-modal-text]');
      if (span) span.textContent = text;
    }

    _openEngravingModal() {
      const modal = this.querySelector('[data-engraving-modal]');
      if (!modal) return;
      const img = this.querySelector('[data-engraving-modal-image]');
      if (img && this._state.cap && this._state.cap.backImage) {
        img.src = this._state.cap.backImage;
        img.alt = this._state.cap.title || 'Back of bottle';
      }
      const input = this.querySelector('[data-engraving-text]');
      this._updateModalText(input ? input.value.trim().slice(0, 3) : '');
      modal.hidden = false;
      requestAnimationFrame(() => modal.classList.add('is-open'));
      if (!this._escHandler) {
        this._escHandler = (e) => { if (e.key === 'Escape') this._closeEngravingModal(); };
        document.addEventListener('keydown', this._escHandler);
      }
    }

    _closeEngravingModal() {
      const modal = this.querySelector('[data-engraving-modal]');
      if (!modal || modal.hidden) return;
      modal.classList.remove('is-open');
      modal.hidden = true;
      if (this._escHandler) {
        document.removeEventListener('keydown', this._escHandler);
        this._escHandler = null;
      }
    }

    _showPreview(part, data) {
      const img = this.querySelector(`[data-preview="${part}"]`);
      if (!img) return;
      if (part === 'cap') {
        if (data.image) { img.src = data.image; img.alt = data.title; }
      } else if (data.overlay) {
        img.src = data.overlay;
        img.classList.add('is-visible');
      } else {
        img.classList.remove('is-visible');
      }
    }

    _clearPreview(part) {
      const img = this.querySelector(`[data-preview="${part}"]`);
      if (img) img.classList.remove('is-visible');
    }

    _isPreorder() {
      return Object.values(this._state).some(s => s && s.preorder);
    }

    _updatePreorder() {
      const isPre = this._isPreorder();
      this.querySelectorAll('[data-atc-label]').forEach(el => {
        el.textContent = isPre ? el.dataset.preorder : el.dataset.default;
      });
      const notice = this.querySelector('[data-preorder-notice]');
      if (notice) notice.hidden = !isPre || !notice.textContent.trim();
    }

    _updateTotal() {
      const entries = Object.entries(this._state).filter(([, v]) => v);
      const total   = entries.reduce((sum, [, s]) => sum + s.price, 0);

      const priceEl = this.querySelector('[data-total-price]');
      if (priceEl) priceEl.textContent = this._fmt(total);
      this.querySelectorAll('[data-atc-price]').forEach(el => { el.textContent = this._fmt(total); });

      const breakdownEl = this.querySelector('[data-total-breakdown]');
      if (breakdownEl) {
        const labels = { cap: this.dataset.labelCap || 'Vessel', sleeve: 'Sleeve', strap: 'Strap' };
        breakdownEl.textContent = entries.length > 1
          ? entries.map(([part, s]) => part === 'engraving' ? 'Engraving' : `${s.colorName} ${labels[part]}`).join(' + ')
          : '';
      }
      this.querySelectorAll('[data-vessel-atc]').forEach(btn => { btn.disabled = !this._state.cap; });
      this._updatePreorder();
    }

    _fmt(cents) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: this._currency, minimumFractionDigits: 2, currencyDisplay: 'narrowSymbol',
        }).format(cents / 100);
      } catch {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    _clearError() {
      const el = this.querySelector('[data-vessel-error]');
      if (el) el.textContent = '';
    }

    _showError(msg) {
      const el = this.querySelector('[data-vessel-error]');
      if (el) el.textContent = msg;
    }

    async _addToCart() {
      if (!this._state.cap) {
        this._showError('Choose a bottle colour to continue.');
        return;
      }
      const notice = (this.dataset.shippingNotice || '').trim();
      const noticeEl = this.querySelector('[data-preorder-notice]');
      const preNote = (noticeEl && noticeEl.dataset.note) || 'Pre-order';
      const capPre = !!(this._state.cap && this._state.cap.preorder);

      const items = Object.entries(this._state)
        .filter(([, s]) => s)
        .map(([part, s]) => {
          const item = { id: s.variantId, quantity: 1 };
          const properties = {};
          if (part === 'engraving') properties['Engraving Text'] = s.text;
          if (notice) properties['Pre-order shipping'] = notice;
          if (s.preorder || (part === 'engraving' && capPre)) properties['Pre-order'] = preNote;
          if (Object.keys(properties).length) item.properties = properties;
          return item;
        });

      const sectionsToBundle = new Set();
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }));

      const atcBtns = this.querySelectorAll('[data-vessel-atc]');
      atcBtns.forEach(btn => btn.setAttribute('aria-busy', 'true'));
      this._clearError();

      try {
        const payload = { items };
        if (sectionsToBundle.size) payload.sections = [...sectionsToBundle].join(',');
        const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');

        const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cart.sections = data.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart },
        }));
      } catch (err) {
        this._showError(err.message || 'Something went wrong, please try again.');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } finally {
        atcBtns.forEach(btn => btn.removeAttribute('aria-busy'));
      }
    }
  }

  customElements.define('vessel-builder-insulated', VesselBuilderInsulated);
}());